import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6033b854"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "modais" }
const _hoisted_2 = {
  class: "modal fade modal-md",
  id: "ModalAtendimentosDetalhados",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalCenterTitle",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  class: "modal-dialog modal-xl",
  role: "document"
}
const _hoisted_4 = {
  class: "modal-content container p-0",
  style: {"border-radius":"10px"}
}
const _hoisted_5 = { class: "modal-header p-4" }
const _hoisted_6 = { class: "imgBack" }
const _hoisted_7 = {
  key: 0,
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#clip0_4762_2891)\" data-v-6033b854><path opacity=\"0.3\" d=\"M29.2961 10.3125H25.7881L24.8131 7.875C23.8111 5.36894 21.4199 3.75 18.7205 3.75H11.2791C8.58026 3.75 6.18846 5.36894 5.18592 7.875L4.21092 10.3125H0.703498C0.245881 10.3125 -0.0898615 10.7426 0.0214666 11.1861L0.373029 12.5924C0.450959 12.9053 0.732209 13.125 1.05506 13.125H2.23104C1.44412 13.8123 0.937287 14.8113 0.937287 15.9375V18.75C0.937287 19.6945 1.29822 20.5471 1.87479 21.2068V24.375C1.87479 25.4104 2.71444 26.25 3.74979 26.25H5.62479C6.66014 26.25 7.49979 25.4104 7.49979 24.375V22.5H22.4998V24.375C22.4998 25.4104 23.3394 26.25 24.3748 26.25H26.2498C27.2851 26.25 28.1248 25.4104 28.1248 24.375V21.2068C28.7013 20.5477 29.0623 19.6951 29.0623 18.75V15.9375C29.0623 14.8113 28.5555 13.8123 27.7691 13.125H28.9451C29.268 13.125 29.5492 12.9053 29.6271 12.5924L29.9787 11.1861C30.0894 10.7426 29.7537 10.3125 29.2961 10.3125ZM8.66756 9.26777C9.09471 8.2002 10.1289 7.5 11.2791 7.5H18.7205C19.8707 7.5 20.9049 8.2002 21.332 9.26777L22.4998 12.1875H7.49979L8.66756 9.26777ZM5.62479 18.7383C4.49979 18.7383 3.74979 17.9906 3.74979 16.8691C3.74979 15.7477 4.49979 15 5.62479 15C6.74979 15 8.43729 16.6822 8.43729 17.8037C8.43729 18.9252 6.74979 18.7383 5.62479 18.7383ZM24.3748 18.7383C23.2498 18.7383 21.5623 18.9252 21.5623 17.8037C21.5623 16.6822 23.2498 15 24.3748 15C25.4998 15 26.2498 15.7477 26.2498 16.8691C26.2498 17.9906 25.4998 18.7383 24.3748 18.7383Z\" fill=\"#203972\" data-v-6033b854></path><path d=\"M8.66777 9.26777C9.09492 8.2002 10.1291 7.5 11.2793 7.5H18.7207C19.8709 7.5 20.9051 8.2002 21.3322 9.26777L22.5 12.1875H7.5L8.66777 9.26777ZM5.625 18.7383C4.5 18.7383 3.75 17.9906 3.75 16.8691C3.75 15.7477 4.5 15 5.625 15C6.75 15 8.4375 16.6822 8.4375 17.8037C8.4375 18.9252 6.75 18.7383 5.625 18.7383ZM24.375 18.7383C23.25 18.7383 21.5625 18.9252 21.5625 17.8037C21.5625 16.6822 23.25 15 24.375 15C25.5 15 26.25 15.7477 26.25 16.8691C26.25 17.9906 25.5 18.7383 24.375 18.7383Z\" fill=\"#203972\" data-v-6033b854></path></g><defs data-v-6033b854><clipPath id=\"clip0_4762_2891\" data-v-6033b854><rect width=\"30\" height=\"30\" fill=\"white\" data-v-6033b854></rect></clipPath></defs>", 2)
const _hoisted_10 = [
  _hoisted_8
]
const _hoisted_11 = {
  key: 1,
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  opacity: "0.3",
  d: "M23.4375 3.75H18.75C18.75 1.68164 17.0684 0 15 0C12.9316 0 11.25 1.68164 11.25 3.75H6.5625C5.00977 3.75 3.75 5.00977 3.75 6.5625V27.1875C3.75 28.7402 5.00977 30 6.5625 30H23.4375C24.9902 30 26.25 28.7402 26.25 27.1875V6.5625C26.25 5.00977 24.9902 3.75 23.4375 3.75ZM15 2.34375C15.7793 2.34375 16.4062 2.9707 16.4062 3.75C16.4062 4.5293 15.7793 5.15625 15 5.15625C14.2207 5.15625 13.5938 4.5293 13.5938 3.75C13.5938 2.9707 14.2207 2.34375 15 2.34375ZM22.1016 15.9258L13.7227 24.2344C13.4473 24.5098 13.002 24.5039 12.7266 24.2285L7.88672 19.3477C7.61133 19.0723 7.61719 18.627 7.89258 18.3516L9.55664 16.6992C9.83203 16.4238 10.2773 16.4297 10.5527 16.7051L13.248 19.4238L19.459 13.2598C19.7344 12.9844 20.1797 12.9902 20.4551 13.2656L22.1074 14.9297C22.3828 15.2109 22.377 15.6504 22.1016 15.9258Z",
  fill: "#203972"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M14.9995 2.34375C15.7788 2.34375 16.4058 2.9707 16.4058 3.75C16.4058 4.5293 15.7788 5.15625 14.9995 5.15625C14.2202 5.15625 13.5933 4.5293 13.5933 3.75C13.5933 2.9707 14.2202 2.34375 14.9995 2.34375ZM22.1011 15.9258L13.7222 24.2344C13.4468 24.5098 13.0015 24.5039 12.7261 24.2285L7.88625 19.3477C7.61086 19.0723 7.61672 18.627 7.89211 18.3516L9.55618 16.6992C9.83157 16.4238 10.2769 16.4297 10.5523 16.7051L13.2476 19.4238L19.4585 13.2598C19.7339 12.9844 20.1792 12.9902 20.4546 13.2656L22.107 14.9297C22.3823 15.2109 22.3765 15.6504 22.1011 15.9258Z",
  fill: "#203972"
}, null, -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 2,
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  opacity: "0.3",
  d: "M25.8398 6.15234L20.1035 0.410156C19.8398 0.146484 19.4824 0 19.1074 0H18.75V7.5H26.25V7.14258C26.25 6.77344 26.1035 6.41602 25.8398 6.15234ZM16.875 7.96875V0H5.15625C4.37695 0 3.75 0.626953 3.75 1.40625V28.5938C3.75 29.373 4.37695 30 5.15625 30H24.8438C25.623 30 26.25 29.373 26.25 28.5938V9.375H18.2812C17.5078 9.375 16.875 8.74219 16.875 7.96875ZM7.5 4.21875C7.5 3.95977 7.70977 3.75 7.96875 3.75H12.6562C12.9152 3.75 13.125 3.95977 13.125 4.21875V5.15625C13.125 5.41523 12.9152 5.625 12.6562 5.625H7.96875C7.70977 5.625 7.5 5.41523 7.5 5.15625V4.21875ZM7.5 8.90625V7.96875C7.5 7.70977 7.70977 7.5 7.96875 7.5H12.6562C12.9152 7.5 13.125 7.70977 13.125 7.96875V8.90625C13.125 9.16523 12.9152 9.375 12.6562 9.375H7.96875C7.70977 9.375 7.5 9.16523 7.5 8.90625ZM15.9375 24.368V25.7812C15.9375 26.0402 15.7277 26.25 15.4688 26.25H14.5312C14.2723 26.25 14.0625 26.0402 14.0625 25.7812V24.358C13.401 24.324 12.7576 24.0932 12.2244 23.693C11.9959 23.5213 11.9842 23.1791 12.191 22.9816L12.8795 22.3248C13.0418 22.1701 13.2832 22.1631 13.473 22.282C13.6998 22.4238 13.957 22.5 14.2242 22.5H15.8713C16.2521 22.5 16.5627 22.1531 16.5627 21.7271C16.5627 21.3785 16.3512 21.0715 16.0488 20.9812L13.4121 20.1902C12.3229 19.8633 11.5617 18.818 11.5617 17.6479C11.5617 16.2111 12.6779 15.0439 14.0619 15.007V13.5938C14.0619 13.3348 14.2717 13.125 14.5307 13.125H15.4682C15.7271 13.125 15.9369 13.3348 15.9369 13.5938V15.017C16.5984 15.051 17.2418 15.2813 17.775 15.682C18.0035 15.8537 18.0152 16.1959 17.8084 16.3934L17.1199 17.0502C16.9576 17.2049 16.7162 17.2119 16.5264 17.093C16.2996 16.9506 16.0424 16.875 15.7752 16.875H14.1281C13.7473 16.875 13.4367 17.2219 13.4367 17.6479C13.4367 17.9965 13.6482 18.3035 13.9506 18.3938L16.5873 19.1848C17.6766 19.5117 18.4377 20.557 18.4377 21.7271C18.4377 23.1645 17.3215 24.3311 15.9375 24.368Z",
  fill: "#203972"
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M25.8398 6.15234L20.1035 0.410156C19.8398 0.146484 19.4824 0 19.1074 0H18.75V7.5H26.25V7.14258C26.25 6.77344 26.1035 6.41602 25.8398 6.15234ZM7.5 4.21875C7.5 3.95977 7.70977 3.75 7.96875 3.75H12.6562C12.9152 3.75 13.125 3.95977 13.125 4.21875V5.15625C13.125 5.41523 12.9152 5.625 12.6562 5.625H7.96875C7.70977 5.625 7.5 5.41523 7.5 5.15625V4.21875ZM7.5 8.90625V7.96875C7.5 7.70977 7.70977 7.5 7.96875 7.5H12.6562C12.9152 7.5 13.125 7.70977 13.125 7.96875V8.90625C13.125 9.16523 12.9152 9.375 12.6562 9.375H7.96875C7.70977 9.375 7.5 9.16523 7.5 8.90625ZM15.9375 24.368V25.7812C15.9375 26.0402 15.7277 26.25 15.4688 26.25H14.5312C14.2723 26.25 14.0625 26.0402 14.0625 25.7812V24.358C13.401 24.324 12.7576 24.0932 12.2244 23.693C11.9959 23.5213 11.9842 23.1791 12.191 22.9816L12.8795 22.3248C13.0418 22.1701 13.2832 22.1631 13.473 22.282C13.6998 22.4238 13.957 22.5 14.2242 22.5H15.8713C16.2521 22.5 16.5627 22.1531 16.5627 21.7271C16.5627 21.3785 16.3512 21.0715 16.0488 20.9812L13.4121 20.1902C12.3229 19.8633 11.5617 18.818 11.5617 17.6479C11.5617 16.2111 12.6779 15.0439 14.0619 15.007V13.5938C14.0619 13.3348 14.2717 13.125 14.5307 13.125H15.4682C15.7271 13.125 15.9369 13.3348 15.9369 13.5938V15.017C16.5984 15.051 17.2418 15.2813 17.775 15.682C18.0035 15.8537 18.0152 16.1959 17.8084 16.3934L17.1199 17.0502C16.9576 17.2049 16.7162 17.2119 16.5264 17.093C16.2996 16.9506 16.0424 16.875 15.7752 16.875H14.1281C13.7473 16.875 13.4367 17.2219 13.4367 17.6479C13.4367 17.9965 13.6482 18.3035 13.9506 18.3938L16.5873 19.1848C17.6766 19.5117 18.4377 20.557 18.4377 21.7271C18.4377 23.1645 17.3215 24.3311 15.9375 24.368Z",
  fill: "#203972"
}, null, -1))
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { class: "d-flex gap-4 p-3 align-items-center" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { style: {"color":"#3699FF"} }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { style: {"color":"#1BC5BD"} }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { style: {"color":"#1BC5BD"} }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_27 = {
  key: 0,
  class: "modal-body d-flex p-5 gap-5 m-0",
  style: {"background":"rgb(249, 249, 249) !important"},
  id: "modalBody"
}
const _hoisted_28 = { class: "card p-4 col" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitulo mb-2" }, "Últimos atendimentos", -1))
const _hoisted_30 = { class: "lista" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "d-flex text-start row header-list-ultimos-atendimentos py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" }, "Placa"),
  /*#__PURE__*/_createElementVNode("div", { class: "col" }, "Status"),
  /*#__PURE__*/_createElementVNode("div", { class: "col" }, "Busca")
], -1))
const _hoisted_32 = { class: "col" }
const _hoisted_33 = { class: "col" }
const _hoisted_34 = { class: "col" }
const _hoisted_35 = { class: "card p-4 col" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitulo mb-3" }, "Atendimentos por região", -1))
const _hoisted_37 = { class: "lista" }
const _hoisted_38 = {
  key: 1,
  class: "modal-body d-flex p-5 gap-5 m-0",
  style: {"background":"rgb(249, 249, 249) !important"},
  id: "modalBody"
}
const _hoisted_39 = { class: "card p-4 col" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitulo mb-3" }, "Atendimentos por região", -1))
const _hoisted_41 = { class: "lista" }
const _hoisted_42 = { class: "card p-4 col" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitulo mb-2" }, "Produtos vendidos nesses atendimentos", -1))
const _hoisted_44 = { class: "lista" }
const _hoisted_45 = {
  key: 2,
  class: "modal-body d-flex p-5 gap-5 m-0",
  style: {"background":"rgb(249, 249, 249) !important"},
  id: "modalBody"
}
const _hoisted_46 = { class: "card p-4 col" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitulo mb-3" }, "Faturamento por produto", -1))
const _hoisted_48 = { class: "lista" }
const _hoisted_49 = { class: "card p-4 col" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitulo mb-2" }, "Ticket Médio por produto", -1))
const _hoisted_51 = { class: "lista" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_Treeview = _resolveComponent("Treeview")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.cardName === 'Todos os Atendimentos')
                ? (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_10))
                : _createCommentVNode("", true),
              (_ctx.cardName === 'Atendimentos finalizados')
                ? (_openBlock(), _createElementBlock("svg", _hoisted_11, _hoisted_14))
                : _createCommentVNode("", true),
              (_ctx.cardName === 'Valor faturado nos atendimentos')
                ? (_openBlock(), _createElementBlock("svg", _hoisted_15, _hoisted_18))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_19, [
              (_ctx.cardName === 'Todos os Atendimentos')
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createVNode(_component_Title, {
                      class: "titulo",
                      description: "Veja mais detalhes sobre todos os atendimentos"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.cardName) + ": ", 1),
                        _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.arrayTodosAtendimentos.length), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.cardName === 'Atendimentos finalizados')
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createVNode(_component_Title, {
                      class: "titulo",
                      description: "Veja mais detalhes sobre os atendimentos finalizados"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.cardName) + ": ", 1),
                        _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.arrayTodosAtendimentos.length), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.cardName === 'Valor faturado nos atendimentos')
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createVNode(_component_Title, {
                      class: "titulo",
                      description: "Veja mais detalhes sobre os atendimentos finalizados"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.cardName) + ": ", 1),
                        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.formataValor(_ctx.faturamentoAtendimentos)), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_26
          ]),
          (_ctx.cardName === 'Todos os Atendimentos')
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("div", null, [
                    _createElementVNode("ul", _hoisted_30, [
                      _hoisted_31,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ultimosAtendimentos, (atendimento, key) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: key,
                          style: {"color":"var(--cor_texto_1)"},
                          class: "d-flex text-start row py-1"
                        }, [
                          _createElementVNode("div", _hoisted_32, _toDisplayString(atendimento.placaVeiculo? atendimento.placaVeiculo: "---------"), 1),
                          _createElementVNode("div", _hoisted_33, _toDisplayString(atendimento.status), 1),
                          _createElementVNode("div", _hoisted_34, _toDisplayString(atendimento.tipoBusca === 'placa'? "Busca placa": "Manual"), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _createElementVNode("ul", _hoisted_37, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.atendimentosPorRegiao, (value, estado, index) => {
                      return (_openBlock(), _createBlock(_component_Treeview, {
                        key: index,
                        folderName: estado,
                        valor: value.atendimentos,
                        arrowColor: '#B5B5C3',
                        folderColor: '#3699FF'
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.atendimentosPorRegiao[estado].gn, (value, regiao, index) => {
                            return (_openBlock(), _createBlock(_component_Treeview, {
                              key: index,
                              folderName: regiao,
                              valor: value.atendimentos,
                              arrowColor: '#B5B5C3',
                              folderColor: '#FFB822'
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.atendimentosPorRegiao[estado].gn[regiao].lojas, (value, loja, index) => {
                                  return (_openBlock(), _createBlock(_component_Treeview, {
                                    key: index,
                                    folderName: loja,
                                    valor: value.atendimentos,
                                    arrowColor: '#B5B5C3',
                                    disableFolder: true,
                                    disableArrow: true
                                  }, null, 8, ["folderName", "valor"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["folderName", "valor"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["folderName", "valor"]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.cardName === 'Atendimentos finalizados')
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _hoisted_40,
                  _createElementVNode("ul", _hoisted_41, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.atendimentosPorRegiao, (value, estado, index) => {
                      return (_openBlock(), _createBlock(_component_Treeview, {
                        key: index,
                        folderName: estado,
                        valor: value.atendimentos,
                        arrowColor: '#B5B5C3',
                        folderColor: '#3699FF'
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.atendimentosPorRegiao[estado].gn, (value, regiao, index) => {
                            return (_openBlock(), _createBlock(_component_Treeview, {
                              key: index,
                              folderName: regiao,
                              valor: value.atendimentos,
                              arrowColor: '#B5B5C3',
                              folderColor: '#FFB822'
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.atendimentosPorRegiao[estado].gn[regiao].lojas, (value, loja, index) => {
                                  return (_openBlock(), _createBlock(_component_Treeview, {
                                    key: index,
                                    folderName: loja,
                                    valor: value.atendimentos,
                                    arrowColor: '#B5B5C3',
                                    disableFolder: true,
                                    disableArrow: true
                                  }, null, 8, ["folderName", "valor"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["folderName", "valor"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["folderName", "valor"]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _hoisted_43,
                  _createElementVNode("div", null, [
                    _createElementVNode("ul", _hoisted_44, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produtosVendidosQtd, (value, tipoProduto, index) => {
                        return (_openBlock(), _createBlock(_component_Treeview, {
                          key: index,
                          folderName: tipoProduto,
                          valor: _ctx.toInteger(value.qtd),
                          arrowColor: '#B5B5C3',
                          folderColor: '#3699FF'
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produtosVendidosQtd[tipoProduto].marcas, (value, marca, index) => {
                              return (_openBlock(), _createBlock(_component_Treeview, {
                                key: index,
                                folderName: marca,
                                valor: _ctx.toInteger(value.qtd),
                                arrowColor: '#B5B5C3',
                                folderColor: '#FFB822'
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produtosVendidosQtd[tipoProduto].marcas[marca].produtos, (value, produto, index) => {
                                    return (_openBlock(), _createBlock(_component_Treeview, {
                                      key: index,
                                      folderName: produto,
                                      valor: _ctx.toInteger(value.qtd),
                                      arrowColor: '#B5B5C3',
                                      disableFolder: true,
                                      disableArrow: true
                                    }, null, 8, ["folderName", "valor"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["folderName", "valor"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["folderName", "valor"]))
                      }), 128))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.cardName === 'Valor faturado nos atendimentos')
            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _hoisted_47,
                  _createElementVNode("ul", _hoisted_48, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produtosFaturamento, (value, tipoProduto, index) => {
                      return (_openBlock(), _createBlock(_component_Treeview, {
                        key: index,
                        folderName: tipoProduto,
                        valor: _ctx.formataValor(value.valor),
                        arrowColor: '#B5B5C3',
                        folderColor: '#3699FF'
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produtosFaturamento[tipoProduto].marcas, (value, marca, index) => {
                            return (_openBlock(), _createBlock(_component_Treeview, {
                              key: index,
                              folderName: marca,
                              valor: _ctx.formataValor(value.valor),
                              arrowColor: '#B5B5C3',
                              folderColor: '#FFB822'
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produtosFaturamento[tipoProduto].marcas[marca].produtos, (value, produto, index) => {
                                  return (_openBlock(), _createBlock(_component_Treeview, {
                                    key: index,
                                    folderName: produto,
                                    valor: _ctx.formataValor(value.valor),
                                    arrowColor: '#B5B5C3',
                                    disableFolder: true,
                                    disableArrow: true
                                  }, null, 8, ["folderName", "valor"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["folderName", "valor"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["folderName", "valor"]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _createElementVNode("div", null, [
                    _createElementVNode("ul", _hoisted_51, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produtosTicketMedio, (value, tipoProduto, index) => {
                        return (_openBlock(), _createBlock(_component_Treeview, {
                          key: index,
                          folderName: tipoProduto,
                          valor: _ctx.formataValor(value.ticketMedio),
                          arrowColor: '#B5B5C3',
                          folderColor: '#3699FF'
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produtosTicketMedio[tipoProduto].marcas, (value, marca, index) => {
                              return (_openBlock(), _createBlock(_component_Treeview, {
                                key: index,
                                folderName: marca,
                                valor: _ctx.formataValor(value.ticketMedio),
                                arrowColor: '#B5B5C3',
                                folderColor: '#FFB822'
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produtosTicketMedio[tipoProduto].marcas[marca].produtos, (value, produto, index) => {
                                    return (_openBlock(), _createBlock(_component_Treeview, {
                                      key: index,
                                      folderName: produto,
                                      valor: _ctx.formataValor(value.ticketMedio),
                                      arrowColor: '#B5B5C3',
                                      disableFolder: true,
                                      disableArrow: true
                                    }, null, 8, ["folderName", "valor"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["folderName", "valor"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["folderName", "valor"]))
                      }), 128))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}